import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function DefaultFee() {
	return (
		<>
			<Trans i18nKey="loan_agreement_guarantor_borrower.default_fee">
				<p>
					<strong>DEFAULT. </strong> If the BORROWER fails to pay the LENDER the Loan and interest in
					accordance with the Agreement, the GUARANTOR shall pay the LENDER the Loan and interest upon demand
					by the LENDER
				</p>
				<p>
					<strong>GUARANTOR FEE. </strong> The BORROWER paid the GUARANTOR a fee in the amount of 1 Php for
					this Guaranty.
				</p>
			</Trans>
		</>
	);
}

export default hot(module)(withTranslation()(DefaultFee));
